import {
	ViewEncapsulation,
	Component,
	Input,
	Output,
	EventEmitter,
	OnInit,
	ComponentRef,
	ViewChild,
	ViewContainerRef,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
} from '@angular/core';
import { COUNTRY_LOOKUP } from './fn-grid-cell.constat';
import { FnComponentRenderService } from './../services/fn-component-render.service';
import { FnGridAbstractCell } from '../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-cell',
	templateUrl: 'fn-grid-cell.component.html',
	styleUrls: ['fn-grid-cell.component.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FnGridCellComponent extends FnGridAbstractCell implements OnInit {
	lookupArray = COUNTRY_LOOKUP;
	rattingArray:Array<any> = [];
	@Output() updateAction = new EventEmitter<any>();
	isLoadCustomComp = false;

	@ViewChild('componentRender', { read: ViewContainerRef })
	container: ViewContainerRef;
	componentRef: ComponentRef<any>;
	constructor(
		private fnCompRenderSvcs: FnComponentRenderService,
		private cdRef: ChangeDetectorRef
	) {
		super();
	}

	override ngOnInit() {
		if (this.column.componentTypeID === 'RATTING') {
			// tslint:disable-next-line: radix

			// tslint:disable-next-line: radix
			const rattingMaxLen = this.cellValue > 5 ? 5 : parseInt(this.cellValue);

			this.rattingArray = new Array(rattingMaxLen);
		}
		if (this.column) {
			if (this.column.componentID) {
				this.isLoadCustomComp = true;
				setTimeout(() => {
					this.componentRef = this.fnCompRenderSvcs.renderComponent(
						this.column.componentID,
						this.container
					);
					this.componentRef.instance.cellValue = this.cellValue;
					this.cdRef.detectChanges();
				}, 0);
			}
		}
	}

	blurRattingAction() {
		// tslint:disable-next-line: radix
		const rattingMaxLen = this.cellValue > 5 ? 5 : parseInt(this.cellValue);
		this.rattingArray = new Array(rattingMaxLen);
		//this.blurAction();
	}

	// blurAction(cellVal:any) {
	// 	this.cellBlur.emit(this.cellValue);
	// }

	// focusAction(cellVal:any){

	// }
	// cellValueChangeAction(cellVal:any){

	// }

	// cellClickAction(cellVal:any){

	// }
}
